'use client';

import { CURRENCY_SYMBOLS } from '@repo/utils/get-numeric-format-props';
import { ReactNode, createContext, useContext } from 'react';

type AmountTextContextType = {
  defaultCurrency: keyof typeof CURRENCY_SYMBOLS;
  useSymbol: boolean;
};

const defaultContext: AmountTextContextType = {
  defaultCurrency: 'USD',
  useSymbol: false,
};

export const AmountTextContext = createContext<AmountTextContextType>(defaultContext);

type AmountTextProviderProps = {
  children: ReactNode;
  defaultCurrency?: keyof typeof CURRENCY_SYMBOLS;
  useSymbol?: boolean;
};

export const AmountTextProvider = ({
  children,
  defaultCurrency = 'USD',
  useSymbol = false,
}: AmountTextProviderProps) => {
  return <AmountTextContext.Provider value={{ defaultCurrency, useSymbol }}>{children}</AmountTextContext.Provider>;
};

export const useAmountText = () => {
  const context = useContext(AmountTextContext);
  if (!context) {
    throw new Error('useAmountText must be used within an AmountTextProvider');
  }
  return context;
};
